module.exports = __webpack_public_path__ + "static/img/SideProjectFarmClubLogo.2710460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SideProjectFarmClubLogo.png
// module id = 63
// module chunks = 1